module.exports = __webpack_public_path__ + "static/img/softprocess.a18f78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/softprocess.png
// module id = +hoj
// module chunks = 0